/**
 * Regional Forms Data - All regional variants from different regions
 * 
 * This file contains all regional forms:
 * - Alolan Forms (Generation 7 - Sun/Moon)
 * - Galarian Forms (Generation 8 - Sword/Shield)
 * - Hisuian Forms (Pokémon Legends: Arceus)
 * - Paldean Forms (Generation 9 - Scarlet/Violet)
 * 
 * IDs start at 20001 to avoid conflicts with regular Pokémon and Megas
 */

// Regional form data - includes all official regional variants
export const REGIONAL_FORMS = [
  // === ALOLAN FORMS (Generation 7) ===
  { id: 20001, name: 'Rattata-Alola', baseName: 'rattata', baseId: 19, region: 'alola', apiName: 'rattata-alola', types: ['dark', 'normal'], inApi: true },
  { id: 20002, name: 'Raticate-Alola', baseName: 'raticate', baseId: 20, region: 'alola', apiName: 'raticate-alola', types: ['dark', 'normal'], inApi: true },
  { id: 20003, name: 'Raichu-Alola', baseName: 'raichu', baseId: 26, region: 'alola', apiName: 'raichu-alola', types: ['electric', 'psychic'], inApi: true },
  { id: 20004, name: 'Sandshrew-Alola', baseName: 'sandshrew', baseId: 27, region: 'alola', apiName: 'sandshrew-alola', types: ['ice', 'steel'], inApi: true },
  { id: 20005, name: 'Sandslash-Alola', baseName: 'sandslash', baseId: 28, region: 'alola', apiName: 'sandslash-alola', types: ['ice', 'steel'], inApi: true },
  { id: 20006, name: 'Vulpix-Alola', baseName: 'vulpix', baseId: 37, region: 'alola', apiName: 'vulpix-alola', types: ['ice'], inApi: true },
  { id: 20007, name: 'Ninetales-Alola', baseName: 'ninetales', baseId: 38, region: 'alola', apiName: 'ninetales-alola', types: ['ice', 'fairy'], inApi: true },
  { id: 20008, name: 'Diglett-Alola', baseName: 'diglett', baseId: 50, region: 'alola', apiName: 'diglett-alola', types: ['ground', 'steel'], inApi: true },
  { id: 20009, name: 'Dugtrio-Alola', baseName: 'dugtrio', baseId: 51, region: 'alola', apiName: 'dugtrio-alola', types: ['ground', 'steel'], inApi: true },
  { id: 20010, name: 'Meowth-Alola', baseName: 'meowth', baseId: 52, region: 'alola', apiName: 'meowth-alola', types: ['dark'], inApi: true },
  { id: 20011, name: 'Persian-Alola', baseName: 'persian', baseId: 53, region: 'alola', apiName: 'persian-alola', types: ['dark'], inApi: true },
  { id: 20012, name: 'Geodude-Alola', baseName: 'geodude', baseId: 74, region: 'alola', apiName: 'geodude-alola', types: ['rock', 'electric'], inApi: true },
  { id: 20013, name: 'Graveler-Alola', baseName: 'graveler', baseId: 75, region: 'alola', apiName: 'graveler-alola', types: ['rock', 'electric'], inApi: true },
  { id: 20014, name: 'Golem-Alola', baseName: 'golem', baseId: 76, region: 'alola', apiName: 'golem-alola', types: ['rock', 'electric'], inApi: true },
  { id: 20015, name: 'Grimer-Alola', baseName: 'grimer', baseId: 88, region: 'alola', apiName: 'grimer-alola', types: ['poison', 'dark'], inApi: true },
  { id: 20016, name: 'Muk-Alola', baseName: 'muk', baseId: 89, region: 'alola', apiName: 'muk-alola', types: ['poison', 'dark'], inApi: true },
  { id: 20017, name: 'Exeggutor-Alola', baseName: 'exeggutor', baseId: 103, region: 'alola', apiName: 'exeggutor-alola', types: ['grass', 'dragon'], inApi: true },
  { id: 20018, name: 'Marowak-Alola', baseName: 'marowak', baseId: 105, region: 'alola', apiName: 'marowak-alola', types: ['fire', 'ghost'], inApi: true },

  // === GALARIAN FORMS (Generation 8) ===
  { id: 20019, name: 'Meowth-Galar', baseName: 'meowth', baseId: 52, region: 'galar', apiName: 'meowth-galar', types: ['steel'], inApi: true },
  { id: 20020, name: 'Ponyta-Galar', baseName: 'ponyta', baseId: 77, region: 'galar', apiName: 'ponyta-galar', types: ['psychic'], inApi: true },
  { id: 20021, name: 'Rapidash-Galar', baseName: 'rapidash', baseId: 78, region: 'galar', apiName: 'rapidash-galar', types: ['psychic', 'fairy'], inApi: true },
  { id: 20022, name: 'Slowpoke-Galar', baseName: 'slowpoke', baseId: 79, region: 'galar', apiName: 'slowpoke-galar', types: ['psychic'], inApi: true },
  { id: 20023, name: 'Slowbro-Galar', baseName: 'slowbro', baseId: 80, region: 'galar', apiName: 'slowbro-galar', types: ['poison', 'psychic'], inApi: true },
  { id: 20024, name: 'Slowking-Galar', baseName: 'slowking', baseId: 199, region: 'galar', apiName: 'slowking-galar', types: ['poison', 'psychic'], inApi: true },
  { id: 20025, name: 'Farfetchd-Galar', baseName: 'farfetchd', baseId: 83, region: 'galar', apiName: 'farfetchd-galar', types: ['fighting'], inApi: true },
  { id: 20026, name: 'Weezing-Galar', baseName: 'weezing', baseId: 110, region: 'galar', apiName: 'weezing-galar', types: ['poison', 'fairy'], inApi: true },
  { id: 20027, name: 'Mr. Mime-Galar', baseName: 'mr-mime', baseId: 122, region: 'galar', apiName: 'mr-mime-galar', types: ['ice', 'psychic'], inApi: true },
  { id: 20028, name: 'Articuno-Galar', baseName: 'articuno', baseId: 144, region: 'galar', apiName: 'articuno-galar', types: ['psychic', 'flying'], inApi: true },
  { id: 20029, name: 'Zapdos-Galar', baseName: 'zapdos', baseId: 145, region: 'galar', apiName: 'zapdos-galar', types: ['fighting', 'flying'], inApi: true },
  { id: 20030, name: 'Moltres-Galar', baseName: 'moltres', baseId: 146, region: 'galar', apiName: 'moltres-galar', types: ['dark', 'flying'], inApi: true },
  { id: 20031, name: 'Corsola-Galar', baseName: 'corsola', baseId: 222, region: 'galar', apiName: 'corsola-galar', types: ['ghost'], inApi: true },
  { id: 20032, name: 'Zigzagoon-Galar', baseName: 'zigzagoon', baseId: 263, region: 'galar', apiName: 'zigzagoon-galar', types: ['dark', 'normal'], inApi: true },
  { id: 20033, name: 'Linoone-Galar', baseName: 'linoone', baseId: 264, region: 'galar', apiName: 'linoone-galar', types: ['dark', 'normal'], inApi: true },
  { id: 20034, name: 'Darumaka-Galar', baseName: 'darumaka', baseId: 554, region: 'galar', apiName: 'darumaka-galar', types: ['ice'], inApi: true },
  { id: 20035, name: 'Darmanitan-Galar', baseName: 'darmanitan', baseId: 555, region: 'galar', apiName: 'darmanitan-galar-standard', types: ['ice'], inApi: true },
  { id: 20036, name: 'Yamask-Galar', baseName: 'yamask', baseId: 562, region: 'galar', apiName: 'yamask-galar', types: ['ground', 'ghost'], inApi: true },
  { id: 20037, name: 'Stunfisk-Galar', baseName: 'stunfisk', baseId: 618, region: 'galar', apiName: 'stunfisk-galar', types: ['ground', 'steel'], inApi: true },

  // === HISUIAN FORMS (Pokémon Legends: Arceus) ===
  { id: 20038, name: 'Growlithe-Hisui', baseName: 'growlithe', baseId: 58, region: 'hisui', apiName: 'growlithe-hisui', types: ['fire', 'rock'], inApi: true },
  { id: 20039, name: 'Arcanine-Hisui', baseName: 'arcanine', baseId: 59, region: 'hisui', apiName: 'arcanine-hisui', types: ['fire', 'rock'], inApi: true },
  { id: 20040, name: 'Voltorb-Hisui', baseName: 'voltorb', baseId: 100, region: 'hisui', apiName: 'voltorb-hisui', types: ['electric', 'grass'], inApi: true },
  { id: 20041, name: 'Electrode-Hisui', baseName: 'electrode', baseId: 101, region: 'hisui', apiName: 'electrode-hisui', types: ['electric', 'grass'], inApi: true },
  { id: 20042, name: 'Typhlosion-Hisui', baseName: 'typhlosion', baseId: 157, region: 'hisui', apiName: 'typhlosion-hisui', types: ['fire', 'ghost'], inApi: true },
  { id: 20043, name: 'Qwilfish-Hisui', baseName: 'qwilfish', baseId: 211, region: 'hisui', apiName: 'qwilfish-hisui', types: ['dark', 'poison'], inApi: true },
  { id: 20044, name: 'Sneasel-Hisui', baseName: 'sneasel', baseId: 215, region: 'hisui', apiName: 'sneasel-hisui', types: ['fighting', 'poison'], inApi: true },
  { id: 20045, name: 'Samurott-Hisui', baseName: 'samurott', baseId: 503, region: 'hisui', apiName: 'samurott-hisui', types: ['water', 'dark'], inApi: true },
  { id: 20046, name: 'Lilligant-Hisui', baseName: 'lilligant', baseId: 549, region: 'hisui', apiName: 'lilligant-hisui', types: ['grass', 'fighting'], inApi: true },
  { id: 20047, name: 'Zorua-Hisui', baseName: 'zorua', baseId: 570, region: 'hisui', apiName: 'zorua-hisui', types: ['normal', 'ghost'], inApi: true },
  { id: 20048, name: 'Zoroark-Hisui', baseName: 'zoroark', baseId: 571, region: 'hisui', apiName: 'zoroark-hisui', types: ['normal', 'ghost'], inApi: true },
  { id: 20049, name: 'Braviary-Hisui', baseName: 'braviary', baseId: 628, region: 'hisui', apiName: 'braviary-hisui', types: ['psychic', 'flying'], inApi: true },
  { id: 20050, name: 'Sliggoo-Hisui', baseName: 'sliggoo', baseId: 705, region: 'hisui', apiName: 'sliggoo-hisui', types: ['steel', 'dragon'], inApi: true },
  { id: 20051, name: 'Goodra-Hisui', baseName: 'goodra', baseId: 706, region: 'hisui', apiName: 'goodra-hisui', types: ['steel', 'dragon'], inApi: true },
  { id: 20052, name: 'Avalugg-Hisui', baseName: 'avalugg', baseId: 713, region: 'hisui', apiName: 'avalugg-hisui', types: ['ice', 'rock'], inApi: true },
  { id: 20053, name: 'Decidueye-Hisui', baseName: 'decidueye', baseId: 724, region: 'hisui', apiName: 'decidueye-hisui', types: ['grass', 'fighting'], inApi: true },

  // === PALDEAN FORMS (Generation 9) ===
  { id: 20054, name: 'Tauros-Paldea-Combat', baseName: 'tauros', baseId: 128, region: 'paldea', apiName: 'tauros-paldea-combat-breed', types: ['fighting'], inApi: true },
  { id: 20055, name: 'Tauros-Paldea-Blaze', baseName: 'tauros', baseId: 128, region: 'paldea', apiName: 'tauros-paldea-blaze-breed', types: ['fighting', 'fire'], inApi: true },
  { id: 20056, name: 'Tauros-Paldea-Aqua', baseName: 'tauros', baseId: 128, region: 'paldea', apiName: 'tauros-paldea-aqua-breed', types: ['fighting', 'water'], inApi: true },
  { id: 20057, name: 'Wooper-Paldea', baseName: 'wooper', baseId: 194, region: 'paldea', apiName: 'wooper-paldea', types: ['poison', 'ground'], inApi: true }
];

// Region colors for styling
export const REGION_COLORS = {
  alola: { bg: 'bg-yellow-500', text: 'text-white', label: { es: 'Alola', en: 'Alola' } },
  galar: { bg: 'bg-rose-500', text: 'text-white', label: { es: 'Galar', en: 'Galar' } },
  hisui: { bg: 'bg-cyan-600', text: 'text-white', label: { es: 'Hisui', en: 'Hisui' } },
  paldea: { bg: 'bg-violet-500', text: 'text-white', label: { es: 'Paldea', en: 'Paldea' } }
};

// Get PokeAPI sprite ID for regional forms
export function getRegionalApiId(apiName) {
  const regionalIds = {
    // Alolan
    'rattata-alola': 10091,
    'raticate-alola': 10092,
    'raichu-alola': 10100,
    'sandshrew-alola': 10101,
    'sandslash-alola': 10102,
    'vulpix-alola': 10103,
    'ninetales-alola': 10104,
    'diglett-alola': 10105,
    'dugtrio-alola': 10106,
    'meowth-alola': 10107,
    'persian-alola': 10108,
    'geodude-alola': 10109,
    'graveler-alola': 10110,
    'golem-alola': 10111,
    'grimer-alola': 10112,
    'muk-alola': 10113,
    'exeggutor-alola': 10114,
    'marowak-alola': 10115,
    // Galarian
    'meowth-galar': 10161,
    'ponyta-galar': 10162,
    'rapidash-galar': 10163,
    'slowpoke-galar': 10164,
    'slowbro-galar': 10165,
    'slowking-galar': 10172,
    'farfetchd-galar': 10166,
    'weezing-galar': 10167,
    'mr-mime-galar': 10168,
    'articuno-galar': 10169,
    'zapdos-galar': 10170,
    'moltres-galar': 10171,
    'corsola-galar': 10173,
    'zigzagoon-galar': 10174,
    'linoone-galar': 10175,
    'darumaka-galar': 10176,
    'darmanitan-galar-standard': 10177,
    'yamask-galar': 10178,
    'stunfisk-galar': 10179,
    // Hisuian
    'growlithe-hisui': 10229,
    'arcanine-hisui': 10230,
    'voltorb-hisui': 10231,
    'electrode-hisui': 10232,
    'typhlosion-hisui': 10233,
    'qwilfish-hisui': 10234,
    'sneasel-hisui': 10235,
    'samurott-hisui': 10236,
    'lilligant-hisui': 10237,
    'zorua-hisui': 10238,
    'zoroark-hisui': 10239,
    'braviary-hisui': 10240,
    'sliggoo-hisui': 10241,
    'goodra-hisui': 10242,
    'avalugg-hisui': 10243,
    'decidueye-hisui': 10244,
    // Paldean
    'tauros-paldea-combat-breed': 10250,
    'tauros-paldea-blaze-breed': 10251,
    'tauros-paldea-aqua-breed': 10252,
    'wooper-paldea': 10253
  };
  return regionalIds[apiName] || null;
}

// Export regional forms as Pokemon-like format for the grid
export function getRegionalFormsAsPokemonList() {
  return REGIONAL_FORMS.map(form => {
    const apiId = getRegionalApiId(form.apiName);
    const spriteUrl = apiId
      ? `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${apiId}.png`
      : `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${form.baseId}.png`;
    return {
      id: form.id,
      name: form.name.toLowerCase().replace(/ /g, '-'),
      displayName: form.name,
      isRegional: true,
      region: form.region,
      baseId: form.baseId,
      baseName: form.baseName,
      types: form.types,
      inApi: form.inApi,
      apiName: form.apiName,
      apiId: apiId, // PokeAPI numeric ID for fetching data
      spriteUrl: spriteUrl // Pre-calculated sprite URL
    };
  });
}

export default REGIONAL_FORMS;
